import React, { lazy } from 'react'
import bankCodeRoutes from '../../CommonSettingsModule/BankCode/BankCodeRoutes'
import BeneficiaryBankCodeListing from '../../CommonSettingsModule/BeneficiaryBankCode/BeneficiaryBankCodeListing'
import companyEFTRoutes from './CompanyEFT/CompanyEFTRoutes'
import exportEFTPaymentRoutes from './ExportEFTPayment/ExportEFTPaymentRoutes'
import generateEFTPaymentRoutes from './GenerateEFTPayment/GenerateEFTPaymentRoutes'
import payeeDetailsRoutes from './PayeeDetails/PayeeDetailsRoutes'
import paymentMethodRoutes from './PaymentMethod/PaymentMethodRoutes'
import paymentPurposeRoutes from './PaymentPurpose/PaymentPurposeRoutes'
export const SettingsRoutes = [
  {
    props: {
      exact: true,
      path: `/bank-eft/:BankEFTID/bank-settings`,
    },
    // component: <SettingsSubmenu />,
  },
  {
    props: {
      exact: true,
      path: `/bank-eft/:BankEFTID/beneficiary-bank-code`,
    },
    component: <BeneficiaryBankCodeListing />,
  },
  {
    props: {
      exact: true,
      path: `/bank-eft/:BankEFTID/bank-profile`,
    },
    // component: <SettingsSubmenu />,
  },
  {
    props: {
      exact: true,
      path: `/bank-eft/:BankEFTID/payment-method`,
    },
    // component: <SettingsSubmenu />,
  },
  {
    props: {
      exact: true,
      path: `/bank-eft/:BankEFTID/payment-purpose`,
    },
    // component: <SettingsSubmenu />,
  },
  {
    props: {
      exact: true,
      path: `/bank-eft/:BankEFTID/export-eft-payment`,
    },
    // component: <SettingsSubmenu />,
  },
  {
    props: {
      exact: true,
      path: `/bank-eft/:BankEFTID/generate-eft-payment`,
    },
    // component: <SettingsSubmenu />,
  },
  ...companyEFTRoutes,
  ...bankCodeRoutes,
  ...exportEFTPaymentRoutes,
  ...generateEFTPaymentRoutes,
  ...payeeDetailsRoutes,
  ...paymentMethodRoutes,
  ...paymentPurposeRoutes,
]

export default SettingsRoutes
